var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flight-container"},[_c('div',{ref:"chart",staticClass:"plot"}),_c('div',{ref:"map",staticClass:"map"},[_c('div',{ref:"altitudeChart",staticClass:"altitude-chart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }